// US postal code: 5 digits, optionally followed by hyphen and 4 digits
const US_POSTAL_CODE_PATTERN = /^\d{5}(-\d{4})?$/;

// Canadian postal code pattern (matches location-service):
const CA_POSTAL_CODE_PATTERN =
	/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ] ?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;

// Range validation configuration
const RANGE_MIN = 1;
const RANGE_MAX = 500;

export const isValidPostalCode = (postalCode) => {
	if (!postalCode || typeof postalCode !== 'string') {
		return false;
	}

	// Trim and convert to uppercase
	const code = postalCode.trim().toUpperCase();

	return (
		US_POSTAL_CODE_PATTERN.test(code) || CA_POSTAL_CODE_PATTERN.test(code)
	);
};

export const parseRange = (range, currentRange) => {
	if (range === undefined || range === null || range === '') {
		return currentRange;
	}

	const parsedRange = parseInt(range, 10);

	if (
		Number.isNaN(parsedRange) ||
		parsedRange < RANGE_MIN ||
		parsedRange > RANGE_MAX
	) {
		return currentRange;
	}

	return parsedRange;
};

export const parseExcludeByRange = (exclude, currentValue) => {
	if (exclude === undefined || exclude === null || exclude === '') {
		return currentValue;
	}

	return Boolean(exclude);
};
